import { Component, forwardRef } from '@angular/core';
import { UserActionBaseComponent } from '../userAction-base.component';
import { DxRadioGroupModule } from 'devextreme-angular';
import { LoginService } from '../../../../Services/login.service';
import { MacroService } from '../../../../Services/CatalogManagement/macro.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'userAction-categoriesToMasters',
  templateUrl: './userAction-categoriesToMasters.component.html',
  styleUrl: './userAction-categoriesToMasters.component.css',
  providers: [
    { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionCategoriesToMastersComponent) }
  ]
})
export class UserActionCategoriesToMastersComponent extends UserActionBaseComponent {

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public translate: TranslateService,
  ) {
    super(loginService, macroService);
  }

    options = [
      { id: 1, name: this.translate.instant('Kategorien mit nur einem Produkt ignorieren')},
      { id: 2, name: this.translate.instant('Kategorien mit nur einem Produkt löschen') },
      { id: 3, name: this.translate.instant('Kategorien mit nur einem Produkt auch umwandeln') }
    ];
    selectedId: number = 1;

    public createParameterStringAsJsonString(): string {

      return JSON.stringify({ selectedOption: this.selectedId });
    }
    public parseParameter(parameter: string) {
      if (!parameter)
        return;
      try {
        const parsed = JSON.parse(parameter);
        this.selectedId = parsed.selectedId;
      } catch (error) {
        console.error('Invalid JSON string provided:', error);
      }
    }

}
